import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrder, IShippingZone } from 'Domain';

interface CheckoutState {
  shippingZones: IShippingZone[];
  currentOrder: IOrder | null;
  loading: boolean;
  error: string | null;
  reservationSuccess: boolean;
}

const initialState: CheckoutState = {
  shippingZones: [],
  currentOrder: null,
  loading: false,
  error: null,
  reservationSuccess: false,
};

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    // Reserve watches
    reserveWatchesRequest: (state, action: PayloadAction<string[]>) => {
      state.loading = true;
      state.error = null;
      state.reservationSuccess = false;
    },
    reserveWatchesSuccess: (state) => {
      state.loading = false;
      state.reservationSuccess = true;
    },
    reserveWatchesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.reservationSuccess = false;
    },

    // Fetch shipping zones
    fetchShippingZonesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchShippingZonesSuccess: (state, action: PayloadAction<IShippingZone[]>) => {
      state.shippingZones = action.payload;
      state.loading = false;
    },
    fetchShippingZonesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },

    // Create order
    createOrderRequest: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    createOrderSuccess: (state, action: PayloadAction<IOrder>) => {
      state.currentOrder = action.payload;
      state.loading = false;
    },
    createOrderFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearCheckout: (state) => {
      state.currentOrder = null;
      state.error = null;
      state.reservationSuccess = false;
    },
  },
});

export const {
  reserveWatchesRequest,
  reserveWatchesSuccess,
  reserveWatchesFailure,
  fetchShippingZonesRequest,
  fetchShippingZonesSuccess,
  fetchShippingZonesFailure,
  createOrderRequest,
  createOrderSuccess,
  createOrderFailure,
  clearCheckout,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
